import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import { listApiKeys } from "../../api/commands/integrations";
import { createTask, listTasks, updateTask } from "../../api/commands/tasks";
import {
	GradeFilter,
	TaskPriority,
	TaskSort,
	TaskStatus,
} from "../../api/schemas/tasks";

export const Message = defineMessageUnion({
	CompletedFetchTasks: {
		generation: S.Number,
		seq: S.Number,
		/** The cursor the page was requested with; null = a fresh first page. */
		cursor: S.NullOr(S.String),
		now: S.Number,
		result: listTasks.Result,
	},
	CompletedFetchKeys: { generation: S.Number, result: listApiKeys.Result },
	ToggledStatus: { status: TaskStatus },
	ToggledPriority: { priority: TaskPriority },
	ToggledTag: { tag: S.String },
	ChangedGradeFilter: { graded: GradeFilter },
	ClearedFilters: {},
	ChangedSort: { sort: TaskSort },
	ChangedQuery: { value: S.String },
	SubmittedSearch: {},
	ClickedLoadMore: {},
	ToggledCollapse: { id: S.String },
	ChangedNewTitle: { value: S.String },
	SubmittedCreate: {},
	CompletedCreate: { generation: S.Number, result: createTask.Result },
	ChangedStatus: { id: S.String, status: TaskStatus },
	ChangedPriority: { id: S.String, priority: TaskPriority },
	CompletedUpdate: { generation: S.Number, result: updateTask.Result },
	DismissedAlert: {},
});
export type Message = typeof Message.Type;
